import React from 'react';
import ChevronDown from 'images/chevron-down.svg';
import Collapse from '@kunukn/react-collapse';
import { graphql, useStaticQuery } from 'gatsby';
import SectionPlain from '../components/SectionPlain';
import './IndustriesWorkedWith.scss';

const IndustriesWorkedWith = () => {
  const {
    industries: {
      childMarkdownRemark: {
        frontmatter: { industries, subTitle, title },
      },
    },
  } = useStaticQuery(
    graphql`
      query {
        industries: file(name: { eq: "industriesWorkedWith" }) {
          childMarkdownRemark {
            frontmatter {
              subTitle
              title
              industries {
                title
                businesses {
                  title
                  url
                }
              }
            }
          }
        }
      }
    `
  );

  const [collapsibles, setCollapsible] = React.useState({
    isOpen1: false,
  });

  const industriesChunked = industries.reduce((all, one, i) => {
    const ch = Math.floor(i / 3);
    // eslint-disable-next-line no-param-reassign
    all[ch] = [].concat(all[ch] || [], one);
    return all;
  }, []);

  const toggleCollapsible = (collapsibleNumber) => {
    const collapsibleState = `isOpen${collapsibleNumber}`;
    setCollapsible((prevState) => ({
      ...prevState,
      [collapsibleState]: !prevState[collapsibleState],
    }));
  };

  const renderCollapsibles = () => (
    <div className="industries-worked__industries">
      {industriesChunked.map((industryChunk, indexChunk) => (
        // eslint-disable-next-line react/no-array-index-key
        <div className="industries-worked__industry-chunk" key={indexChunk}>
          {industryChunk.map((industry) => (
            <div
              className="industries-worked__industry-wrapper"
              key={industry.title}
              data-sal="slide-up"
              data-sal-easing="ease"
              data-sal-delay="100"
            >
              <button
                className="industries-worked__industry"
                onClick={() => toggleCollapsible(industry.title)}
                type="button"
              >
                <h3 className="industries-worked__industry-title">{industry.title}</h3>
                <ChevronDown
                  className={`industries-worked__chevron ${
                    collapsibles[`isOpen${industry.title}`] && 'industries-worked__chevron--active'
                  }`}
                />
              </button>
              <Collapse
                isOpen={collapsibles[`isOpen${industry.title}`]}
                className={`industries-worked__collapse industries-worked__collapse--gradient ${
                  collapsibles[`isOpen${industry.title}`]
                    ? 'industries-worked__collapse--active'
                    : ''
                }`}
              >
                <>
                  {industry.businesses.map((business) => (
                    <a
                      className="industries-worked__business"
                      href={business.url}
                      target="_blank"
                      rel="noreferrer"
                      key={`${business.title}${industry.title}`}
                    >
                      {business.title}
                    </a>
                  ))}
                </>
              </Collapse>
            </div>
          ))}
        </div>
      ))}
    </div>
  );

  return (
    <SectionPlain className="industries-worked" subTitle={subTitle} title={title} titleH2>
      {renderCollapsibles()}
    </SectionPlain>
  );
};

export default IndustriesWorkedWith;
